import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DashboardState } from "./dashboard-state";
import { RootState } from "../../api/store";

const initialState: DashboardState = {
    collapsed: false,
    openMenu: null,
    mobileSidebar: false
};

const dashboardSlice = createSlice({
    name: "dashboardSlice",
    initialState,
    reducers: {
        setBooleanValue: (state, action: PayloadAction<{type: 'col' | 'ms'; value: boolean}>) => {
            const { type, value } = action.payload;
            if(type === 'col') {
                state.collapsed = value;
                return;
            }
            if(type === 'ms') {
                state.mobileSidebar = value;
                return;
            }
        },
        setStringValue: (state, action: PayloadAction<{type: 'om'; value: string | null}>) => {
            const {type, value} = action.payload;
            if(type === 'om') {
                state.openMenu = value;
            }
        },
        setMobileSidebar: (state, action: PayloadAction<boolean>) => {
            state.mobileSidebar = action.payload;
        },
    },
});

export const { 
    setBooleanValue,
    setStringValue,
} = dashboardSlice.actions;

export const selectCollapsed = (state: RootState) => state.dashboardSlice.collapsed;
export const selectOpenMenu = (state: RootState) => state.dashboardSlice.openMenu;
export const selectMobileSidebar = (state: RootState) => state.dashboardSlice.mobileSidebar;

export default dashboardSlice.reducer;
